import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import OAuth from "./OAuth";
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider, extendTheme, ColorModeScript } from "@chakra-ui/react";
import { datadogRum } from "@datadog/browser-rum";

const oauthPage = window.location.pathname.startsWith("/oauth/");
if (!oauthPage) datadogRum.init({
  applicationId: "563551ed-abc6-4d0b-9e91-a9ec0c15fd3c",
  clientToken: "pubb6133cd45b31e48bc60467cfae8f5f30",
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: "datadoghq.com",
  service: "balldontlie-app",
  env: "prod",
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "mask-user-input",
});

const theme = extendTheme({
  config: {
    initialColorMode: "dark",
    useSystemColorMode: false,
  },
  colors: {
    brand: {
      50: "#EEF6FF",
      100: "#DBEAFE",
      200: "#BFDBFE",
      300: "#93C5FD",
      400: "#3B82F6",
      500: "#4F46E5",
      600: "#4338CA",
      700: "#3730A3",
      800: "#312E81",
      900: "#1E1B4B",
    },
    gray: {
      50: "#F8FAFC",
      100: "#F1F5F9",
      200: "#E2E8F0",
      300: "#CBD5E1",
      400: "#A7B2C5",
      500: "#7D8DA5",
      600: "#52617A",
      700: "#2E3B52",
      800: "#182337",
      900: "#0B1020",
    },
  },
  semanticTokens: {
    colors: {
      accent: {
        default: "brand.600",
        _dark: "brand.300",
      },
    },
  },
  styles: {
    global: {
      "html, body": {
        bg: "gray.900",
        backgroundImage:
          "radial-gradient(circle at 18% 0%, rgba(59, 130, 246, 0.12), transparent 34%), radial-gradient(circle at 82% 8%, rgba(139, 92, 246, 0.10), transparent 28%)",
        backgroundAttachment: "fixed",
      },
      "*::selection": {
        bg: "#67E8F9",
        color: "gray.900",
      },
    },
  },
});

ReactDOM.render(
  <>
    <ColorModeScript initialColorMode={"dark"} />
    <React.StrictMode>
      <BrowserRouter>
        <ChakraProvider theme={theme}>
          {oauthPage ? <OAuth /> : <App />}
        </ChakraProvider>
      </BrowserRouter>
    </React.StrictMode>
  </>,
  document.getElementById("root")
);
